import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { PerformerParamTypes, uploadLocalContentPerformer } from './uploadLocalContentPerformer';
import { globalErrorResponse, showNotification, TYPE_ERROR } from '../../../../store/notifications/actions';
import isNil from 'lodash/isNil';
import { invalidateLocalContentPerformers } from './useLocalContentPerformers';
import { useTranslation } from 'react-i18next';

export const useUploadLocalContentPerformer = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    return useMutation(
        ({ performer, photo }: PerformerParamTypes) => uploadLocalContentPerformer({ performer, photo }),
        {
            onSuccess: (data, variables) => {
                invalidateLocalContentPerformers().then();
                return isNil(variables.performer.id) ? data.performerId : variables.performer.id;
            },
            onError: (error: any) => {
                if (error.response.status === 400) {
                    dispatch(showNotification(t('notifications.useUploadLocalContentPerformer.error'), TYPE_ERROR));
                } else {
                    dispatch(globalErrorResponse(error.response));
                }
                return Promise.reject(error);
            }
        }
    );
};
